import HomeContainer from 'containers/business/HomeContainer'
import SummaryListContainer from 'containers/business/SummaryListContainer'
import ReservationListContainer from 'containers/business/ReservationListContainer'
import ReservationContainer from 'containers/business/ReservationContainer'
import BillingContainer from 'containers/business/Billing'
import EmployeeListContainer from 'containers/business/EmployeeListContainer'
import SettingContainer from 'containers/business/SettingContainer'
import SignupContainer from 'containers/business/SignupContainer'
import SignupDoneContainer from 'containers/business/SignupDoneContainer'
import ConsiderationContainer from 'containers/business/ConsiderationContainer'
import JoinContainer from 'containers/business/JoinContainer'
import RequestToJoinContainer from 'containers/business/RequestToJoinContainer'
import Path from './path'

export default [
  {
    path: Path.home(),
    exact: true,
    component: HomeContainer,
  },
  {
    path: Path.join(),
    exact: true,
    component: JoinContainer,
  },
  {
    path: Path.requestToJoin(),
    exact: true,
    component: RequestToJoinContainer,
  },
  {
    path: Path.summaries(),
    exact: true,
    component: SummaryListContainer,
  },
  {
    path: Path.reservations(),
    exact: true,
    component: ReservationListContainer,
  },
  {
    path: Path.reservation(),
    exact: true,
    component: ReservationContainer,
  },
  {
    path: Path.reservationBilling(),
    exact: true,
    component: BillingContainer,
  },
  {
    path: Path.setting(),
    exact: true,
    component: SettingContainer,
  },
  {
    path: Path.employees(),
    exact: true,
    component: EmployeeListContainer,
  },
  {
    path: Path.signup(),
    exact: true,
    component: SignupContainer,
  },
  {
    path: Path.signupCompanyForm(),
    exact: true,
    component: SignupContainer,
  },
  {
    path: Path.signupConfirmCompanyForm(),
    exact: true,
    component: SignupContainer,
  },
  {
    path: Path.signupDone(),
    exact: true,
    component: SignupDoneContainer,
  },
  {
    path: Path.considaration(),
    exact: true,
    component: ConsiderationContainer,
  },
]
